import type { FC } from 'react';
import { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import BaseListItem from '../BaseListItem';
import BaseListCell from '../BaseListItem/BaseListCell';
import DeviationThumb from '../../_partials/DeviationThumb';
import DeviationTitle from '../../_partials/DeviationTitle';
import DeviationInfo from '../../_partials/DeviationInfo';
import DeviationActions from '../../../tableActions/DeviationActions';
import CommissionStatusEdit from '../../_partials/CommissionStatusEdit';
import CommissionPriceEdit from '../../_partials/CommissionPriceEdit';
import { StudioDeviationListContext } from '../../context';

import s from './CommissionListItem.scss';

interface Props {
  deviation: PapiDeviation;
  offset: number;
}

const CommissionListItem: FC<Props> = ({ deviation, offset }) => {
  const { actionsColRef, actionsColWidth } = useContext(
    StudioDeviationListContext
  );
  // We use the first row as a probe to determine the size of columns
  const shouldAddColumnRefs = offset === 0;

  return (
    <BaseListItem>
      <BaseListCell>
        <DeviationThumb deviation={deviation} />
      </BaseListCell>
      <BaseListCell className={s['cell-title']}>
        <DeviationTitle deviation={deviation} showSaleIndicators={false} />
        <DeviationInfo deviation={deviation} />
      </BaseListCell>
      <BaseListCell>
        <div className={s['controls']}>
          <CommissionPriceEdit deviation={deviation} />
          <CommissionStatusEdit deviation={deviation} />
        </div>
      </BaseListCell>
      <BaseListCell
        ref={shouldAddColumnRefs ? actionsColRef : undefined}
        overflowHidden
      >
        <DeviationActions
          deviation={deviation}
          offset={offset}
          columnWidth={actionsColWidth}
        />
      </BaseListCell>
    </BaseListItem>
  );
};
CommissionListItem.displayName = 'CommissionListItem';

export default CommissionListItem;
